export default __webpack_public_path__ + "static/media/kid-gamer.0ec1ffbb.png";